import type { AuthContextProps } from "react-oidc-context";

// Bridge so non-React code (e.g. axios interceptors) can drive a silent renew
// on the SAME UserManager react-oidc-context owns — keeping its events and
// TokenSync in sync. Registered from TokenSync, which holds the live useAuth().

let authRef: AuthContextProps | null = null;
let refreshPromise: Promise<string | null> | null = null;

export const registerAuth = (auth: AuthContextProps) => {
  authRef = auth;
};

export const silentRenew = (): Promise<string | null> => {
  if (!authRef) return Promise.resolve(null);

  if (!refreshPromise) {
    refreshPromise = authRef
      .signinSilent()
      .then((user) => user?.access_token ?? null)
      .finally(() => {
        refreshPromise = null;
      });
  }

  return refreshPromise;
};
